<template>
  <div>
    <div class="bg-img--wrapper" v-if="slideActive.type">
      <div
        class="transition-start-bg slide-image-bg"
        :class="{'slide-type-image-bg': documentImageVisible}"
        :style="{ 'background-image': 'url(' + transitionOldBackgroundImage + ')',
                  'background-size': `${slideActive.backgroundSize || 'cover'}` }"
      >
        <div
          class="transition-end-bg"
          :class="{'animate__animated animate__fadeIn':showingAnimationClass}"
        >
          <div
            class="slide-image-bg"
            :class="{'slide-type-image-bg': documentImageVisible}"
            :style="{
              'background-image': 'url(' + transitionBackgroundImage + ')',
              'background-color': transitionBaseColour,
              'background-size': `${slideActive.backgroundSize || 'cover'}`
            }"
          />
        </div>
      </div>
      <div
        class="slide-full-size slide-base-colour"
        :class="{'no-opacity': documentImageVisible}"
        :style="{ 'background-color': transitionBaseColour, 'opacity': slideVisibility }"
      />
    </div>

    <!-- Image slide -->
    <div
      class="slide-type-image-bg"
      :class="{
        'slide-type-img-fs': imageSlideBackgroundVisible,
        'transition-image-slide-bg': showingAnimationImgSlideBackground
      }"
      v-if="imageSlideBackgroundVisible"
      id="slide-type-image-bg"
      :style="{ 'background-image': 'url(' + transitionSlideImageFullScreen + ')' }"
    />
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import EventBus from '@/eventBus'

export default {
  data() {
    return {
      firstTimeLoaded: true,
      transitionBackgroundImage: '',
      transitionBaseColour: '',
      transitionOldBackgroundImage: '',
      transitionSlideImageFullScreen: '',
      showingAnimationClass: false,
      showingAnimationImgSlideBackground: false,
    }
  },
  computed: {
    ...mapGetters(['isPresenting']),
    ...mapState({
      activeSlideId: (state) => state.activeSlideId,
      presentation: (state) => state.presentation,
      currentUser: (state) => state.currentUser,
      slideActive: (state) => state.slideActive,
      sharePresentation: (state) => state.sharePresentation,
    }),
    documentImageVisible() {
      return this.slideActive.image && (this.slideActive.type === 'document' || this.slideActive.type === 'freestyle')
    },
    imageSlideBackgroundVisible() {
      const { type, image, imageType } = this.slideActive
      return type === 'image' && image && imageType === 'background'
    },
    backgroundAndDocumentImageVisible() {
      const { backgroundImage, image, type } = this.slideActive
      return backgroundImage || (image && type === 'document')
    },
    slideVisibility() {
      const { backgroundImage, backgroundCache, visibility } = this.slideActive
      if (backgroundImage || backgroundCache) {
        if (visibility) {
          if (visibility == 0) {
            return 0.999
          }
          return 1 - (visibility / 100)
        } if (visibility == 0) {
          return 0.999
        }
        return null
      }
      return null
    },
  },
  watch: {
    activeSlideId() {
      if (this.firstTimeLoaded) {
        this._setValueForTransition()
        this.firstTimeLoaded = false
      }
    },
  },
  mounted() {
    EventBus.$on('eventHandleSetValueTransition', () => {
      this._setValueNoAnimationForChangeSlide()
    })
    EventBus.$on('setValueForTransition', () => {
      this._setValueForTransition()
    })
    EventBus.$on('updateValueWhenTransitionEnds', () => {
      this._updateValueWhenTransitionEnds()
    })
    EventBus.$on('checkShowingAnimationImgSlideBackground', () => {
      this._checkShowingAnimationImgSlideBackground()
    })
    EventBus.$on('changeShowingAnimationClass', (value) => {
      this.showingAnimationClass = value
    })
  },
  destroyed() {
    EventBus.$off('eventHandleSetValueTransition')
    EventBus.$off('setValueForTransition')
    EventBus.$off('updateValueWhenTransitionEnds')
    EventBus.$off('checkShowingAnimationImgSlideBackground')
    EventBus.$off('changeShowingAnimationClass')
  },
  methods: {
    async _setValueNoAnimationForChangeSlide() {
      const {
        image, backgroundImage, baseColour, backgroundCache,
      } = this.slideActive

      if (this.documentImageVisible) {
        this._setTransitionImage(image.xLarge, 'old')
      } else if (backgroundCache || backgroundImage) {
        this._setTransitionImage(backgroundCache || backgroundImage.xLarge, 'old')
      } else if (!backgroundImage || !this.documentImageVisible) {
        this._setTransitionImage(null, 'old')
      }
      if (this.imageSlideBackgroundVisible) {
        this.transitionSlideImageFullScreen = image.xLarge
      } else {
        this.transitionSlideImageFullScreen = null
      }
      this.transitionBaseColour = baseColour || '#ffffff'
    },

    _setTransitionImage(image, old) {
      this.transitionBackgroundImage = image
      if (old) {
        this.transitionOldBackgroundImage = image
      }
    },

    _setValueForTransition() {
      const {
        baseColour, image, type, backgroundImage, backgroundCache,
      } = this.slideActive
      this.transitionBaseColour = baseColour || '#ffffff'
      if (backgroundCache || backgroundImage) {
        if (type === 'document' && image && image.xLarge) {
          this._setTransitionImage(image.xLarge)
        } else {
          this._setTransitionImage(backgroundCache || backgroundImage.xLarge)
        }
      } else if (this.documentImageVisible) {
        this._setTransitionImage(image.xLarge)
      } else if (!backgroundImage || !this.documentImageVisible) {
        this._setTransitionImage(null)
      }
      if (this.imageSlideBackgroundVisible) {
        this.transitionSlideImageFullScreen = image.xLarge
      }
    },

    _updateValueWhenTransitionEnds() {
      setTimeout(() => {
        const { backgroundImage, image, backgroundCache } = this.slideActive
        this.showingAnimationClass = false
        if (backgroundCache || backgroundImage) {
          this.transitionOldBackgroundImage = backgroundCache || backgroundImage.large
        } else if (this.documentImageVisible) {
          this.transitionOldBackgroundImage = image.large
        } else if (!backgroundImage || !this.documentImageVisible) {
          this.transitionOldBackgroundImage = null
        }
      }, 500)
    },

    _checkShowingAnimationImgSlideBackground() {
      if (this.imageSlideBackgroundVisible && this.isPresenting) {
        this.showingAnimationImgSlideBackground = true
      } else if (this.imageSlideBackgroundVisible && !this.isPresenting) {
        this.showingAnimationImgSlideBackground = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.bg-img--wrapper {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}
.transition-end-bg {
  width: 100%;
  height: 100%;
  &.animate__animated {
    animation-duration: 0.5s;
    animation-timing-function: cubic-bezier(0.25, 1, 0.5, 1);
  }
}
.transition-start-bg {
  width: 100%;
  height: 100%;
}
.slide-base-colour {
  background-color: #000;
}
.slide-type-image-bg, .slide-image-bg {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;

  &.gif-image {
    background-size: cover;
  }
}

.slide-type-img-fs {
  background-size: contain;
}

.slide-full-size {
  width: 100%;
  height: 100%;

  &.no-opacity {
    opacity: 1 !important;
  }
}
</style>
